module.exports = __webpack_public_path__ + "img/tips4.f3141aae.png";